import ministryService from "../../../../services";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: () => {
    return {
      working: false,
    };
  },
  getters: {
    working(state) {
      return state.working;
    },
  },
  mutations: {
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async validateNgo({ commit }, { id, status }) {
      commit("setWorking", true);
      return new Promise(async (resolve, reject) => {
        try {
          const res = await ministryService.validateNgo(id, status);
          if (hasError(res.status)) {
            reject(res.status);
          } else resolve();
        } catch (err) {
          reject();
        } finally {
          commit("setWorking", false);
        }
      });
    },
  },
};
